import { getToken, _fetch } from "./apiHelper";
import { protectedResources } from "../config/authConfig";
import { PaginatedResponse } from "../types/paginatedResponse";

export const getRecommendations = async (
  pageSize : number,
  continuationToken : string,
  controller : AbortController
): Promise<PaginatedResponse> => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
    signal: controller.signal,
  };

  const ps = pageSize.toString();
  return _fetch(
    protectedResources.api.training +
      "?" +
      new URLSearchParams({ pageSize : ps, continuationToken }),
    options
  );
};

export const createRecommendation = async (formData : FormData) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  const options = {
    method: "POST",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: formData,
  };

  return _fetch(protectedResources.api.training, options);
};

export const editMedia = async ( recommendationId : string, formData : FormData, workspaceId? : string) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  const options = {
    method: "POST",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: formData,
  };

  return _fetch(
    protectedResources.api.training + `/media/${workspaceId}/${recommendationId}`,
    options
  );
};

export const getMediaUrl = async ( recommendationId : string,  file : string, workspaceId? : string) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
  };


  return _fetch(
    protectedResources.api.training + `/media/${workspaceId}/${recommendationId}/${file}`,
    options
  );
};
